/**
 * DevExtreme (esm/__internal/scheduler/r1/components/wrappers/time_panel.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _extends from "@babel/runtime/helpers/esm/extends";
import registerComponent from "../../../../../core/component_registrator";
import { ComponentWrapper } from "../../../../core/r1/index";
import { TimePanelTable } from "../base/time_panel_table";
export class TimePanelComponent extends ComponentWrapper {
  _setOptionsByReference() {
    super._setOptionsByReference();
    this._optionsByReference = _extends({}, this._optionsByReference, {
      timeCellTemplate: true
    });
  }
  get _propsInfo() {
    return {
      twoWay: [],
      allowNull: [],
      elements: [],
      templates: ["timeCellTemplate"],
      props: ["viewContext", "groupOrientation", "timePanelData", "timeCellTemplate"]
    };
  }
  get _viewComponent() {
    return TimePanelTable;
  }
}
registerComponent("dxTimePanelTableLayout", TimePanelComponent);